import { render, staticRenderFns } from "./SantralInfo.vue?vue&type=template&id=01de94c4&scoped=true&"
import script from "./SantralInfo.vue?vue&type=script&lang=js&"
export * from "./SantralInfo.vue?vue&type=script&lang=js&"
import style0 from "./SantralInfo.vue?vue&type=style&index=0&id=01de94c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01de94c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VDataTable,VDivider,VIcon,VListItem,VListItemContent,VListItemTitle,VSpacer})
